import React, { useState, useEffect } from 'react'
import CustomSelect from '../../../../../../Components/Common/CustomSelect'
import Sizes from '../FilterModal/Sizes';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { bannerOptions } from '../../../../../../common/showcase';
import { setBannerFilter, setSelectedShowcaseVersion, setSelectedSizes } from '../../../../../../slices/showcase/reducer';
import { setPreloader } from '../../../../../../slices/layouts/reducer';
import { getFilteredSizes } from '../../../../../../slices/showcase/thunk';

function FilterTab() {
  const dispatch = useDispatch();

  const selectCreatives = createSelector(state => state, state => ({
    versions: state.Campaign.versions,
    selectedShowcaseVersion: state.Showcase.selectedShowcaseVersion,
    bannerFilter: state.Showcase.bannerFilter,
    showcaseSizes: state.Showcase.showcaseSizes,
    selectedSizes: state.Showcase.selectedSizes
  }));
  const { versions, selectedShowcaseVersion, bannerFilter, showcaseSizes, selectedSizes } = useSelector(selectCreatives);
  const [isSelectedAll, setIsSelectedAll] = useState(false);    
  const [versionOptions, setVersionOptions] = useState([]);
  const [selectedFilterState, setSelectedFilterState] = useState(null);

  useEffect(() => {
    if (versions) {
      setVersionOptions([
        { value: 'all', name: 'All Versions' },
        ...versions.map(item => { return { value: item._id, name: item.name } })
      ]);
    }
  }, [versions]);

  useEffect(() => {
    async function getSizes() {
      await dispatch(getFilteredSizes());
    }
    if (selectedShowcaseVersion) {
      getSizes();
    }
  }, [selectedShowcaseVersion]);

  function selectVersion(item) {
    dispatch(setSelectedShowcaseVersion(item))
    if (!bannerFilter) {
      selectBannerFilter(bannerOptions[0]);
    }
  }

  function selectBannerFilter(item) {
    setSelectedFilterState(item);
    dispatch(setBannerFilter(item))
  }

  function handleSelect(selectedItem, selectedIdx) {
    const foundSize = selectedSizes.find((item, idx) => item._id === selectedItem._id);
    if (foundSize) {
      dispatch(setSelectedSizes(selectedSizes.filter((item, idx) => item._id !== selectedItem._id)));
    } else {
      dispatch(setSelectedSizes([...selectedSizes, selectedItem]))
    }
  }

  function selectAll() {
    dispatch(setSelectedSizes(showcaseSizes));
    setIsSelectedAll(true);
  }

  function deselectAll() {
    dispatch(setSelectedSizes([]));
    setIsSelectedAll(false);
  }

  function isChecked(selectedItem, idx) {    
    return selectedSizes.some(item => item._id === selectedItem._id);
  }

  return (
    <div className='w-100 d-flex flex-column'>
      <CustomSelect
        placeholder='Select Versions'
        options={versionOptions}
        onChange={(item) => selectVersion(item)}
      />
      <CustomSelect
        className='form-select mt-1'
        placeholder='Select Banner Filter'  
        options={bannerOptions}
        onChange={(item => selectBannerFilter(item))}
        value={selectedFilterState ? selectedFilterState.name : ''}
      />
      {showcaseSizes ?
        <div className='mt-3'>
          <Sizes
            creatives={showcaseSizes}
            selectedSizes={selectedSizes}
            handleSelect={handleSelect}
            isSelectedAll={isSelectedAll}
            selectAll={selectAll}
            deselectAll={deselectAll}
            isChecked={(item, idx) => isChecked(item, idx)}
            columnWidth='3'
          />
        </div>
        : null}
    </div>
  )
}

export default FilterTab
